import * as types from '@/store/types'

// Actions commit mutations and may contain arbitrary asynchronous operations.
// Read more: https://vuex.vuejs.org/guide/actions.html
export default {
  setAccuracy ({commit}, {accuracy, isAccuracyValid}) {
    commit(types.MISSION__SET_ACCURACY, {accuracy, isAccuracyValid})
  },
  [types.IMG__UPDATE_TRANSFORMATION] ({commit}, transformations) {
    commit(types.IMG__UPDATE_TRANSFORMATION, transformations)
  },
  [types.IMG__TOGGLE_THRESHOLD] ({state, commit}, imgId) {
    const {hasThreshold} = state.filters[imgId]
    commit(types.IMG__TOGGLE_THRESHOLD, {imgId, hasThreshold: !hasThreshold})
  },
  [types.IMG__UPDATE_THRESHOLD_VALUE] ({commit}, {imgId, value}) {
    commit(types.IMG__UPDATE_THRESHOLD_VALUE, {imgId, value})
  },
  toggleLoading(context,truth) {
    context.commit('update_loading', truth)
  }
}
